/* ============================================================================
   Yummy Combs info page — interactions only.
   All CONTENT is rendered by Liquid from section settings/blocks.
   This file only wires behavior (accordions, carousels, slider, tabs, strips).
   Idempotent: safe to run multiple times; re-inits on Shopify section load.
   ========================================================================== */
(function () {
  if (window.YCInfoInit) { return; }   /* asset may be linked by several sections */
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var done = function (n) { return n.dataset.ycInit === '1'; };
  var mark = function (n) { n.dataset.ycInit = '1'; };

  /* ---- tooth-decay stages: hover/tap reveals description ---- */
  function stages(root) {
    $$('[data-yc-stages]', root).forEach(function (wrap) {
      if (done(wrap)) return; mark(wrap);
      var desc = $('[data-yc-stage-desc]', wrap.closest('[data-yc-stages-scope]') || document);
      var cards = $$('.yc-stage', wrap);
      function show(c) { cards.forEach(function (x) { x.classList.remove('is-active'); }); c.classList.add('is-active'); if (desc) desc.textContent = c.getAttribute('data-desc') || ''; }
      cards.forEach(function (c) {
        c.addEventListener('mouseenter', function () { show(c); });
        c.addEventListener('click', function () { show(c); });
      });
      if (cards[0]) show(cards[0]);
    });
  }

  /* ---- before/after drag slider ---- */
  function beforeAfter(root) {
    $$('[data-yc-ba]', root).forEach(function (ba) {
      if (done(ba)) return; mark(ba);
      var before = $('[data-yc-ba-before]', ba), handle = $('[data-yc-ba-handle]', ba), drag = false;
      function set(x) {
        var r = ba.getBoundingClientRect();
        var p = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
        before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
        handle.style.left = p + '%';
      }
      handle.addEventListener('mousedown', function () { drag = true; });
      handle.addEventListener('touchstart', function () { drag = true; }, { passive: true });
      window.addEventListener('mouseup', function () { drag = false; });
      window.addEventListener('touchend', function () { drag = false; });
      window.addEventListener('mousemove', function (e) { if (drag) set(e.clientX); });
      window.addEventListener('touchmove', function (e) { if (drag) set(e.touches[0].clientX); }, { passive: true });
      ba.addEventListener('click', function (e) { if (!handle.contains(e.target)) set(e.clientX); });
    });
  }

  /* ---- fade carousel: one slide visible, dots + arrows + autoplay ---- */
  function carousel(root) {
    $$('[data-yc-carousel]', root).forEach(function (car) {
      if (done(car)) return; mark(car);
      var slides = $$('[data-yc-slide]', car);
      if (!slides.length) return;
      var dotsWrap = $('[data-yc-dots]', car) || (car.parentNode && car.parentNode.querySelector('[data-yc-dots]'));
      var i = 0, timer, delay = parseInt(car.getAttribute('data-autoplay') || '0', 10);
      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (_, idx) {
          var d = document.createElement('button');
          d.className = 'yc-dot' + (idx === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          d.addEventListener('click', function () { go(idx); reset(); });
          dotsWrap.appendChild(d); dots.push(d);
        });
      }
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.style.display = idx === i ? '' : 'none'; });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }
      function reset() { if (!delay) return; clearInterval(timer); timer = setInterval(function () { go(i + 1); }, delay); }
      var next = $('[data-yc-next]', car), prev = $('[data-yc-prev]', car);
      if (next) next.addEventListener('click', function () { go(i + 1); reset(); });
      if (prev) prev.addEventListener('click', function () { go(i - 1); reset(); });
      go(0); reset();
    });
  }

  /* ---- horizontal scroll strip with arrow buttons (UGC photos/videos/reviews) ---- */
  function strips(root) {
    $$('[data-yc-strip]', root).forEach(function (strip) {
      if (done(strip)) return; mark(strip);
      var track = $('.yc-strip__track', strip);
      $$('.yc-strip__nav', strip).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-dir') || '1', 10);
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---- flavor toggle inside a buy tier ---- */
  function flavors(root) {
    $$('[data-yc-flavors]', root).forEach(function (grp) {
      if (done(grp)) return; mark(grp);
      var btns = $$('.yc-flavor', grp);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
        });
      });
    });
  }

  /* ---- tabs (nutrition flavors) ---- */
  function tabs(root) {
    $$('[data-yc-tabs]', root).forEach(function (grp) {
      if (done(grp)) return; mark(grp);
      var scope = grp.closest('[data-yc-tabs-scope]') || document;
      var tabBtns = $$('.yc-tab', grp);
      var panels = $$('[data-yc-panel]', scope);
      tabBtns.forEach(function (t, idx) {
        t.addEventListener('click', function () {
          tabBtns.forEach(function (x) { x.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (panels[idx]) panels[idx].classList.add('is-active');
        });
      });
    });
  }

  /* ---- wellness chips (expand/collapse) ---- */
  function chips(root) {
    $$('.yc-chip', root).forEach(function (chip) {
      if (done(chip)) return; mark(chip);
      chip.addEventListener('click', function () { chip.classList.toggle('is-open'); });
    });
  }

  /* ---- FAQ accordion ---- */
  function faq(root) {
    $$('.yc-faqitem', root).forEach(function (item) {
      if (done(item)) return; mark(item);
      var q = $('.yc-faqq', item), a = $('.yc-faqa', item);
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      });
    });
  }

  function init(root) {
    root = root || document;
    stages(root); beforeAfter(root); carousel(root); strips(root);
    flavors(root); tabs(root); chips(root); faq(root);
  }

  window.YCInfoInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }

  /* Shopify theme editor: re-init a section when it (re)loads */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
